import { Component, Input } from '@angular/core';

export type MessageBandMode =
  | 'error'
  | 'error-soft'
  | 'error-outline'
  | 'warning'
  | 'warning-soft'
  | 'info'
  | 'info-white';

interface StyleObject {
  'font-family'?: string;
  'font-weight'?: string | number;
  'font-size'?: string;
  color?: string;
}

@Component({
  selector: 'lib-cdw-message-band',
  templateUrl: './cdw-message-band.component.html',
  styleUrls: ['./cdw-message-band.component.scss'],
  standalone: false,
  host: {
    '[class.full-width]': 'fullWidth'
  }
})
export class CdwMessageBandComponent {
  @Input() public mode: MessageBandMode = 'error';

  @Input() public fontFamily?: string;

  @Input() public fontWeight?: string | number;

  @Input() public fontSize?: string;

  @Input() public textColor?: string;

  @Input() public fullWidth = false;

  @Input() public infoTitle?: string;

  @Input() public infoTitleColor?: string;

  @Input() public infoTitleWeight?: string | number;

  /** Override the mode-derived icon glyph (Material Symbols name). */
  @Input() public icon?: string;

  get iconName(): string {
    if (this.icon) return this.icon;
    if (this.mode === 'info-white' || this.mode === 'warning-soft') {
      return 'info';
    }
    if (this.mode === 'error-soft') {
      return 'error';
    }
    if (this.mode === 'error-outline') {
      return 'warning';
    }
    return this.mode;
  }

  get customStyles(): StyleObject {
    const styles: StyleObject = {};
    if (this.fontFamily) {
      styles['font-family'] = this.fontFamily;
    }
    if (this.fontWeight) {
      styles['font-weight'] = this.fontWeight;
    }
    if (this.fontSize) {
      styles['font-size'] = this.fontSize;
    }
    if (this.textColor) {
      styles.color = this.textColor;
    }
    return styles;
  }

  get titleStyles(): StyleObject {
    const styles: StyleObject = {};
    if (this.infoTitleColor) {
      styles.color = this.infoTitleColor;
    }
    if (this.infoTitleWeight) {
      styles['font-weight'] = this.infoTitleWeight;
    }
    return styles;
  }
}
